module.exports = __webpack_public_path__ + "img/major_bu7fj1.093c34fb.svg";